module.exports = __webpack_public_path__ + "static/media/Crayfish-Pool-Robot-Manual.252e1132.pdf";